<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M-.812-.437h20.874v20.874H-.812V-.437z" />
    <path
      d="M17.99 2.995l1.858 1.832L6.801 18.062.043 11.829l1.77-1.918 4.9 4.52L17.99 2.995z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
